import React from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { setCurrentBook } from "../../../store/BookSlice";
import { MenuTemplate } from "../../_templates/MenuTemplate";

export const Menu = () => {
  const dispatch = useDispatch();
  const params = useParams();
  
  dispatch(setCurrentBook(params.book - 1));
  
  return (
    <MenuTemplate />
  );
};